import { Search, Plus } from "lucide-react";
import { Button } from "@/shared/components/form/Button";
import useTranslations from "@/shared/lang/useTranslations";

type AccountsWalletsHeaderProps = {
  searchValue: string;
  onSearchChange: (value: string) => void;
  onAddAccountClick?: () => void;
};

export const AccountsWalletsHeader = ({
  searchValue,
  onSearchChange,
  onAddAccountClick,
}: AccountsWalletsHeaderProps) => {
  const { t } = useTranslations("accountsWallets");
  return (
    <header className="sticky top-0 z-10 border-b border-slate-200 dark:border-zinc-800 bg-white/80 dark:bg-zinc-900/80 backdrop-blur-md px-4 md:px-8 py-4">
      <div className="max-w-7xl mx-auto flex flex-wrap items-center justify-between gap-4">
        <div>
          <h1 className="text-2xl font-extrabold text-slate-900 dark:text-white tracking-tight">
            {t("header_title")}
          </h1>
          <p className="text-slate-500 dark:text-slate-400 text-sm mt-0.5">
            {t("header_subtitle")}
          </p>
          <p className="text-slate-400 dark:text-slate-500 text-xs mt-1.5">
            {t("header_hint")}
          </p>
        </div>
        <div className="flex items-center gap-4">
          <div className="relative">
            <Search
              className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400 dark:text-slate-500 h-5 w-5"
              aria-hidden
            />
            <input
              type="text"
              value={searchValue}
              onChange={(e) => onSearchChange(e.target.value)}
              placeholder={t("search_placeholder")}
              className="pl-10 pr-4 py-2 bg-slate-100 dark:bg-zinc-800 border-0 rounded-lg text-sm focus:ring-2 focus:ring-green-500 dark:focus:ring-green-400 w-56 md:w-64 transition-all text-slate-900 dark:text-white placeholder-slate-500 dark:placeholder-slate-400"
              aria-label={t("search_placeholder")}
            />
          </div>
          {onAddAccountClick && (
            <Button
              variant="primary"
              onClick={onAddAccountClick}
              icon={<Plus className="h-4 w-4" />}
              iconPosition="left"
              className="whitespace-nowrap shadow-lg shadow-green-500/20"
            >
              {t("add_account")}
            </Button>
          )}
        </div>
      </div>
    </header>
  );
};
